// When the user scrolls down 20px from the top of the document, slide down the navbar
window.onscroll = function() {scrollFunction()};

function scrollFunction() {
	if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
		document.getElementById("hidden-navbar").style.top = "0";
		document.getElementById("hidden-navbar").classList.add("hidden-navbar-toggle");
	} else {
		document.getElementById("hidden-navbar").style.top = "-100px";
		document.getElementById("hidden-navbar").classList.remove("hidden-navbar-toggle");
		document.getElementById("aboutNavHover").classList.remove("about-nav-hover-visible");
	}
}
$('.hidden-burger-navigation').on('click', function(){
	console.log('nav');
	$('.hidden-nav-hover').toggleClass('hidden-nav-hover-toggle');
	$('.hidden-burger-navigation').toggleClass('toggle-nav-icon');
});

$('.burger-navigation, .mobile-nav-btn').on('click', function(){
		console.log('nav');
	$('.burger-navigation, .mobile-nav-btn').toggleClass('toggle-nav-icon');
});

$('#servicesMegaMenu').on('click', function(){
	$('.services-mega-menu').toggleClass('services-mega-menu-visible');
	$('body').toggleClass('body-fixed');
});
$('.services-mega-menu-close').on('click', function(){
	$('.services-mega-menu').removeClass('services-mega-menu-visible');
	$('body').removeClass('body-fixed');
});

// Open Submenu About
$('#aboutHoverMenu').on('click', function(){
	$('.about-nav-hover').toggleClass('nav-hover-visible');
	if ($(".services-nav-hover").hasClass("nav-hover-visible")) {
		$(".services-nav-hover").toggleClass('nav-hover-visible');
	}
});

// Open Submenu Services
$('#servicesHoverMenu').on('click', function(){
	$('.services-nav-hover').toggleClass('nav-hover-visible');
	if ($(".about-nav-hover").hasClass("nav-hover-visible")) {
		$(".about-nav-hover").toggleClass('nav-hover-visible');
	}
});

 $(document).on('keyup', function(e) {
   if (e.key == "Escape")
   		$(".about-nav-hover").removeClass('nav-hover-visible'); 
   		$(".services-nav-hover").removeClass('nav-hover-visible'); 
});

// Close any open menus on scroll over 100px
$(document).ready(function() {
    $(window).scroll(function() {
        if ($(document).scrollTop() > 100) {
           $('.about-nav-hover').removeClass('nav-hover-visible');
           $('.services-nav-hover').removeClass('nav-hover-visible');
        }
    });
}); 


